import { BrowserRouter as Router, Switch, Redirect } from 'react-router-dom';

// components
import Home from '../views/Landing/Home';
import PublicRoute from './PublicRoute';


const Routes = () => {
    return (
        <Router>
            <Switch>
                <PublicRoute path='/' component={Home} exact />
                <Redirect path='*' to='/' exact />
            </Switch>
        </Router>
    );
}

export default Routes;